import { TUnitListingMdl } from "admin/units/_models/UnitListingMdl";
import React from "react";
import { useCurrency } from "_common/currency/CurrencyProvider";
import { calculateAndFormatPropertyPrice } from "_common/_utils/propertyUtils";
import { IconFavorite } from "properties/propertyPage/icons/IconFavorite";
import { useTranslation } from "react-i18next";
import { IconButton } from "@material-ui/core";

type Props = {
    unit: TUnitListingMdl;
    isInPesosProperty: boolean;
};

export const PropertyFavoriteCardUnits = ({ unit, isInPesosProperty }: Props) => {
    const { currentCurrency } = useCurrency();
    const { t } = useTranslation();
    const price = calculateAndFormatPropertyPrice(
        {
            priceMin: unit.price,
            priceInPesosMin: unit.priceInPesos,
            priceIsInPesos: isInPesosProperty,
        },
        currentCurrency,
    );
    return (
        <div key={unit._id} className={"text-xs border-b p-1 px-2 flex items-center"}>
            <div className={"flex items-center gap-1"}>
                <span>{unit.name}</span>
                <span>-</span>
                <span>
                    {" "}
                    {t(`unitPage.header.numberOfRoom`, {
                        count: unit.bedrooms ?? 0,
                        context: `${unit.bedrooms}`,
                    })}
                </span>
                <span>-</span>
                <span>{price}</span>
            </div>
            <IconButton className={"!ml-auto"} size={"small"}>
                <IconFavorite color={"black"} size={"8"} isFavorite={true} />
            </IconButton>
        </div>
    );
};
